import React from 'react'
import loadable from '@loadable/component'

import { Props as ComponentProps } from 'component-library/banners/SocialBanner/SocialBanner'
import { createRegisterableComponent } from 'common/routing/page-definition'

export const LazySocialBanner = loadable(() =>
    import('component-library/banners/SocialBanner/SocialBanner')
)

// Use current set of props for now
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SocialBannerRouteProps extends ComponentProps {}

export const SocialBannerRegistration = createRegisterableComponent(
    'social-banner',
    (props: SocialBannerRouteProps) => <LazySocialBanner {...props} />
)
